export const environment = {
  production: false,
  environmentName: 'development',
  apiUrl: '/api',
  telegramBot: 'TestAiChatBot2_bot'
};
